/**
 * Pre-made stack-rank profiles. Each profile's `attributes` is ordered by
 * priority — the first entry gets the highest weight under the falloff.
 */
export interface RankProfile {
    id: string;
    name: string;
    description: string;
    attributes: string[];
}

export const RANK_PROFILES: RankProfile[] = [
    {
        id: "young_professional",
        name: "Young Professional",
        description: "Commute, after-work drinks, gym before work",
        attributes: [
            "connectivity",
            "drink_with_friends",
            "coffee_and_cake",
            "gym",
            "evening_at_restaurant",
            "restaurants",
        ],
    },
    {
        id: "family_life",
        name: "Family Life",
        description: "Quiet, green, low crime, weekly shop nearby",
        attributes: [
            "crime",
            "green_space",
            "grocery_shops",
            "getting_outside",
            "noise",
            "connectivity",
        ],
    },
    {
        id: "nightlife_and_culture",
        name: "Nightlife & Culture",
        description: "Late nights, gigs, eating out — the city after dark",
        attributes: [
            "night_life",
            "drink_with_friends",
            "club_night",
            "culture",
            "movie_or_show",
            "restaurants",
        ],
    },
    {
        id: "active_outdoors",
        name: "Active & Outdoors",
        description: "Running paths, parks, fitness studios, sports clubs",
        attributes: [
            "exercise",
            "getting_outside",
            "green_space",
            "gym",
            "group_fitness",
            "sports",
        ],
    },
    {
        id: "cosy_homebody",
        name: "Cosy Homebody",
        description: "Takeaway, weekly shop, quiet streets, a garden centre",
        attributes: [
            "take_away_and_telly",
            "grocery_shops",
            "noise",
            "crime",
            "home_goods_and_diy",
            "green_space",
        ],
    },
    {
        id: "foodie_and_culture",
        name: "Foodie & Culture",
        description: "Restaurants, coffee shops, theatres, weekend wandering",
        attributes: [
            "restaurants",
            "evening_at_restaurant",
            "coffee_and_cake",
            "culture",
            "movie_or_show",
            "drink_with_friends",
        ],
    },
    {
        id: "shoppers_paradise",
        name: "Shopper's Paradise",
        description: "High streets, malls, retail therapy — easy commute back",
        attributes: [
            "retail_therapy",
            "clothing_shops",
            "department_stores_shopping_centers",
            "coffee_and_cake",
            "connectivity",
            "restaurants",
        ],
    },
];
